/**
 * @readonly
 * @enum {string}
 */
export const TeamFlippedState = {
  Hidden: "hidden"
}
